import { BaseTag }   from "mixs/base/base_mixin";
import jump from 'jump.js'
export class LogsJump extends BaseTag {
  orders: any[];
  select: HTMLInputElement;
  init(){
    super.init();
    const data = this.data()
    this.orders = []
    const orderIds = this.opts.orderIds.split(',')
    for(let i=0; i<orderIds.length; i++){
      const orderId = orderIds[i]
      const d = data['orders_info_' + orderId]
      this.orders.push(d)
      console.log(d)
    }
    this.listenMount([this.onMountLogsJump])
  }
  onMountLogsJump() {
    const scope = this
    this.select = this.querySelector('select') as HTMLInputElement
    this.select.addEventListener('change', (e) => { this.onChangeSelect() })
  }
  onChangeSelect(){
    jump("#card-order-" + this.select.value)
  }
}
riot.mixin('logs.jump', LogsJump as riot.TagMixin)
